module.exports = __webpack_public_path__ + "img/apcsppsets.5e89b944.png";